/*****************************************************
CONVERT - GOALS FIJOS
Goals permanentes de Convert.com. NO forman parte de ninguna prueba A/B:
no se registran en manifests de convert-tests/ y no se eliminan en deploy ni cleanup.
Se carga en todo el sitio desde layout/theme.liquid.
Para agregar un goal: crear una función nueva siguiendo el mismo patrón.
*****************************************************/
(function() {
  function triggerGoal(goalId, name) {
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["triggerConversion", goalId]);
    console.log('Trigger - Goal - ' + name);
  }

  /*****************************************************
  GOAL - Click Sticky ATC (1004127916)
  Se dispara cuando el usuario agrega un producto al carrito desde el Sticky Add to Cart
  (PDP normal y PDP de bundles). Se usa delegación de eventos porque el product linking
  reemplaza el sticky al cambiar sabor/tamaño.
  *****************************************************/
  document.addEventListener('click', function(event) {
    var button = event.target.closest('.main-product-atc-button, .main-product-atc-bundles-button');
    if (!button || button.disabled || button.classList.contains('disabled')) return;
    triggerGoal('1004127916', 'Click Sticky ATC');
  });
})();
